var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"150px !important"},attrs:{"src":require("@/assets/images/app/rsd.png"),"alt":"Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }